import type { BaseTranslation } from '../i18n-types';

export const auth = {
    login: 'Login',
    signin: 'Sign in',
    signinGoogle: 'Sign in with Google',
    signup: 'Sign up',
    signupForFree: 'Sign up for free',
    signupEmail: 'Sign up with email',
    signupGoogle: 'Sign up with Google',
    logout: 'Logout',
    report: {
        text: 'To report content without registration,',
        link: 'click here',
    },
    selfInfo: {
        title: 'Tell us about yourself',
        description: 'Please enter the nickname you want to have in the chat and specify what languages you speak.',
    },
    signupMeta: {
        title: `Join for free - {appName:string}`,
        desc: `Create free account on {appName:string} and have a random video calls with people from all over the world.`,
    },
    loginMeta: {
        title: `Login - {appName:string}`,
        desc: `Log in to your account on {appName:string} to start your video call or chat with strangers.`,
    },
    buyMembership: 'Buy membership',
    buyMinutes: 'Buy minutes',
    title: 'Sign up to start video chat',
    titleFreeMinutes: 'Sign up to get <span>{minutes:number} minutes for free!</span>',
    titleFreeSeconds: 'Sign up to get <span>{seconds:number} seconds for free!</span>',
    story: {
        title: 'Sign up for free to watch more or wait',
    },
    features: {
        chat: '1-on-1 private video chat',
        privacy: 'Only real women, no fake',
        meetPeople: 'Automatically translate messages',
    },
    spokenLangRange: 'Languages (up to 6)',
    terms: 'By signing in, logging, or creating an account, you agree with our <a class="link" href="{termsOfUseLink:string}" target="_blank">Terms & Conditions</a> and <a class="link" href="{privacyLink:string}" target="_blank">Privacy Policy</a>.',
    alreadyMember: 'Already have an account?',
    notMember: 'Not a member yet?',
    rememberMe: 'Remember me',
    forgotPassword: 'Forgot password',
    usernameEmail: 'Email or username',
    nickname: 'Nickname',
    password: 'Password',
    email: 'Email',
    completeButtonLabel: 'Complete',
    confirmPassword: 'Confirm your password',
} satisfies BaseTranslation;
